// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__n7gXu","rightAdornment":"Header_rightAdornment__33e-f"};